
import ResultTestComponent from "@/components/RegisterTest/ResultTest/ResultTestComponent";
export default ResultTestComponent;
